import { render, staticRenderFns } from "./undistributed-case.vue?vue&type=template&id=1bda57d9"
import script from "./undistributed-case.vue?vue&type=script&lang=ts"
export * from "./undistributed-case.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports